import React, { Suspense, lazy, Fragment } from 'react';
import './App.css';

import { Switch, Route, Redirect } from 'react-router-dom';
import Home from './pages/Home';
import ProjectDetail from './pages/projectDetail';
import TeamDetail from './pages/teamDetail';
import About from './pages/about';
import Contact from './pages/contact';
import projectData from './assets/projectsData';

import Layout from './components/layout/Layout';
import Syllabus from './components/syllabus';

//const ProjectDetail = lazy(() => import('./pages/projectDetail'));
// const Home = lazy(() => import('./pages/home'));

function App() {
  const Loading = () => {
    return (
      <div>
        <h2>Loading ...</h2>
      </div>
    );
  };
  return (
    <Layout>
      <Switch>
        <Route path='/' exact>
          <Home projectData={projectData} />
        </Route>
        <Route path='/team/:id'>
          <TeamDetail />
        </Route>
        <Route path='/projectinfo/:id'>
          <ProjectDetail projectData={projectData} />
        </Route>
        <Route path='/about'>
          <About />
        </Route>
        <Route path='/home'>
          <Redirect to='/' />
        </Route>
        <Route path='/contact'>
          <Contact />
        </Route>
        <Route path='/classes/:id'>
          <Syllabus />
        </Route>
        <Route path='*'>
          <Redirect to='/' />
        </Route>
      </Switch>
    </Layout>
  );
}

export default App;
